<template>
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="{ 'is-rotated': !props.isOpen }"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6187 15.6187C16.277 15.9604 15.723 15.9604 15.3813 15.6187L10 10.2374L4.61872 15.6187C4.27701 15.9604 3.72299 15.9604 3.38128 15.6187C3.03957 15.277 3.03957 14.723 3.38128 14.3813L9.38128 8.38128C9.72299 8.03957 10.277 8.03957 10.6187 8.38128L16.6187 14.3813C16.9604 14.723 16.9604 15.277 16.6187 15.6187Z"
      fill="#202020"
    />
  </svg>
</template>

<script setup lang="ts">
  interface IProps {
    isOpen?: boolean;
  }
  const props = defineProps<IProps>();
</script>
<style lang="scss" scoped>
  .is-rotated {
    transform: rotate(180deg);
  }
</style>
